function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 641.94,
    height: 145.76,
    viewBox: "0 0 641.94 145.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M517.08,84.79h46.45c5.13,0,4.7,3.77,4.37,5.04l-1.15,4.3c-.9,3.45-4.17,5.74-7.72,5.4h-69.81l-6.24,23.36h76.05c28.08,0,32.36-22.64,32.36-22.64l4.79-17.96c1.38-5.66,3.26-21.19-18.3-21.19h-46.41c-5.17,0-4.72-3.77-4.41-5.06l1.17-4.3c.92-3.46,4.19-5.74,7.75-5.41h69.81l6.24-23.34h-76.04c-28.09,0-32.37,22.64-32.37,22.64l-4.85,17.98c-1.34,5.68-3.23,21.19,18.3,21.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.65,108.14L641.94,0H83.01c-31.64,0-50.49,20.75-54.71,40.24L3.87,131.33l-3.87,14.43h563.48c23.01,0,43.16-15.42,49.17-37.63M602.55,102.88c-2.32,11.17-14.24,31.49-43.51,31.49H15l24.53-91.37c2.25-11.22,14.17-31.54,43.49-31.54h390.54l21.64,24.73,6.66-24.68h125.2l-24.51,91.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.14,43.11c-6.21-7-17.94-20.15-17.94-20.15h-70.73l-26.68,99.92h26.25l20.43-76.39h43.7l2.68,3.06c1.43,1.91,1.79,4.41.96,6.64-.22.87-17.88,66.68-17.88,66.68h26.22l16.98-63.56c1.49-5.72,0-11.81-3.98-16.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6,45.55l-4.83,18c-1.38,5.66-3.26,21.19,18.28,21.19h46.47c5.13,0,4.7,3.77,4.36,5.02l-1.15,4.32c-.91,3.45-4.18,5.74-7.74,5.4H36.19l-6.3,23.38h76.03c28.07,0,32.39-22.64,32.39-22.64l4.83-17.98c1.36-5.66,3.25-21.19-18.28-21.19h-46.45c-5.15,0-4.68-3.77-4.34-5.08l1.13-4.3c.89-3.45,4.15-5.73,7.7-5.4h69.92l6.23-23.34h-76.03c-28.13,0-32.41,22.62-32.41,22.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.86,43.11c-6.26-7-17.96-20.15-17.96-20.15h-70.73l-26.77,99.99h26.21l10.23-38.19h49.94c-4.85,18.11-10.24,38.19-10.24,38.19h26.24l16.98-63.56c1.56-5.74.09-11.87-3.88-16.28M350.39,56.19c0,.15-.55,2.08-1.38,5.17h-49.92l3.98-14.87h43.71l2.64,3.06c1.46,1.89,1.82,4.41.96,6.64",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.3 22.94 169.93 22.92 163.69 46.28 200.76 46.28 180.25 122.86 208.23 122.86 228.8 46.22 266.06 46.22 272.3 22.94",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.47,129.75c1.37,0,2.68.34,3.93,1.02s2.24,1.66,2.96,2.94,1.08,2.61,1.08,4-.35,2.71-1.06,3.97-1.68,2.24-2.94,2.94-2.58,1.06-3.97,1.06-2.71-.35-3.97-1.06-2.24-1.68-2.94-2.94-1.06-2.58-1.06-3.97.36-2.73,1.08-4,1.7-2.25,2.96-2.94,2.56-1.02,3.93-1.02ZM609.48,131.31c-1.1,0-2.15.27-3.15.82s-1.8,1.33-2.38,2.36-.87,2.1-.87,3.22.28,2.18.85,3.19,1.35,1.8,2.37,2.37,2.07.85,3.18.85,2.18-.28,3.19-.85,1.8-1.36,2.37-2.37.85-2.08.85-3.19-.29-2.2-.87-3.22-1.37-1.81-2.38-2.36-2.06-.82-3.16-.82ZM605.87,141.98v-8.45h1.72c1.61,0,2.51,0,2.7.02.57.05,1.01.16,1.33.34s.58.45.79.81.32.77.32,1.21c0,.61-.2,1.13-.6,1.56s-.96.7-1.68.81c.26.1.45.2.59.32s.33.33.57.65c.06.08.27.43.62,1.03l1,1.71h-2.12l-.71-1.37c-.48-.92-.87-1.5-1.19-1.74s-.71-.36-1.19-.36h-.45v3.47h-1.72ZM607.59,137.17h.7c.99,0,1.61-.04,1.85-.11s.43-.21.57-.4.21-.41.21-.65-.07-.45-.2-.63-.33-.32-.58-.4-.86-.12-1.84-.12h-.7v2.31Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStans);
export default __webpack_public_path__ + "static/media/stans.e9f8e5603e34d15060d896d34141353e.svg";
export { ForwardRef as ReactComponent };